
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Reintegro } from '@/models';
import ItemListReintegro from "./ItemListReintegro.vue";

@Component({
    components: { ItemListReintegro }
})
export default class ReintegriList extends Vue {
    @Prop() private reintegri!: Reintegro[];    
}
